// The CSV shape for the task stats payload. Split out of the export menu so the
// menu itself is shared with the Bookings and Traffic dashboards and only the
// table layout differs per dashboard.
export function taskStatsCsv(stats, filters) {
  return {
    meta: [
      ['Generated', new Date().toISOString()],
      ['Range', `${stats.range.start} to ${stats.range.end}`],
      ['Priorities', filters.priorities.join(' ') || 'all'],
      ['Colours', filters.colors.join(' ') || 'all'],
      ['Task type', filters.taskType],
      ['Cancelled included', filters.includeCanceled ? 'yes' : 'no'],
    ],
    sections: [
      {
        name: 'Headline figures',
        headers: ['Metric', 'Value', 'Previous period'],
        rows: Object.entries(stats.kpis).map(([key, m]) => [key, m?.value ?? '', m?.previous ?? '']),
      },
      {
        name: 'Created vs completed',
        headers: ['Date', 'Created', 'Completed'],
        rows: stats.over_time.map(d => [d.date, d.created, d.completed]),
      },
      {
        name: 'Open by status',
        headers: ['Status', 'Count'],
        rows: stats.by_status.map(d => [d.status, d.count]),
      },
      {
        name: 'By priority',
        headers: ['Priority', 'Completed', 'Open', 'Overdue'],
        rows: stats.by_priority.map(d => [d.priority, d.completed, d.open, d.overdue]),
      },
      {
        name: 'Cycle time',
        headers: ['Bucket', 'Count'],
        rows: stats.cycle_time.map(d => [d.bucket, d.count]),
      },
      {
        name: 'Overdue aging',
        headers: ['Bucket', 'Count'],
        rows: stats.overdue_aging.map(d => [d.bucket, d.count]),
      },
      {
        name: 'Longest open',
        headers: ['Title', 'Age (days)', 'Priority', 'Status', 'Due', 'Overdue'],
        rows: stats.longest_open.map(r => [r.title, r.age_days, r.priority, r.status, r.due_at || '', r.is_overdue ? 'yes' : 'no']),
      },
    ],
  }
}
